<div class="d-flex flex-row" style="cursor: pointer">
    <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-column mr-2">
            <h4 class="mb-0"><i class="bi bi-bell-fill mr-1"></i> {{ taskCount }} task{{ taskCount > 1 ? 's' : '' }} coming up in the next 30 minutes</h4>
        </div>
        <button class="ml-2 mr-2" (click)="dismiss()">Dismiss</button>
        <button class="ml-auto" (click)="viewTasks()">View</button>
    </div>
</div>
